/**
 * Viewer overlay for blocking interactions during graph selection
 */
export class ViewerOverlay {
    constructor() {
        this.overlay = null;
        this.isVisible = false;
        this.onCancel = null;
        this.createElement();
    }

    /**
     * Create the overlay DOM element
     */
    createElement() {
        this.overlay = document.createElement('div');
        this.overlay.id = 'viewer-overlay';
        this.overlay.className = 'fixed top-0 left-0 right-0 bottom-0 bg-black/75 backdrop-blur-md z-[998] hidden flex-col items-center justify-center gap-6 p-8';

        // Create main content container
        const contentContainer = document.createElement('div');
        contentContainer.className = 'flex flex-col items-center gap-6 max-w-md';

        // Create icon
        const iconContainer = document.createElement('div');
        iconContainer.className = 'w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl animate-pulse';
        iconContainer.innerHTML = `
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
            </svg>
        `;

        // Create title
        const title = document.createElement('div');
        title.className = 'text-white text-2xl font-bold text-center';
        title.textContent = 'Sélection de la destination';

        // Create message
        const message = document.createElement('div');
        message.className = 'text-slate-300 text-center text-lg leading-relaxed';
        message.innerHTML = `
            Cliquez sur une image dans le <strong class="text-blue-400">panneau Graph</strong> à droite<br>
            pour choisir la destination de votre connexion
        `;

        // Create cancel button
        const cancelButton = document.createElement('button');
        cancelButton.className = 'mt-4 px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105';
        cancelButton.innerHTML = `
            <span class="flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
                <span>Annuler</span>
            </span>
        `;
        cancelButton.addEventListener('click', () => {
            if (this.onCancel) {
                this.onCancel();
            }
        });

        contentContainer.appendChild(iconContainer);
        contentContainer.appendChild(title);
        contentContainer.appendChild(message);
        contentContainer.appendChild(cancelButton);

        this.overlay.appendChild(contentContainer);

        // Append to body but position it to cover viewer area only
        document.body.appendChild(this.overlay);

        // Adjust overlay to not cover sidebar in sandbox mode
        this.adjustOverlayPosition();
        console.log('✅ Viewer overlay created');
    }

    /**
     * Adjust overlay position based on sidebar presence
     */
    adjustOverlayPosition() {
        // Check if sidebar exists (sandbox mode)
        const sidebar = document.getElementById('sandbox-panel');
        if (sidebar && this.overlay) {
            // Get sidebar width
            const sidebarWidth = sidebar.offsetWidth || 800;
            // Adjust overlay to not cover sidebar
            this.overlay.style.right = `${sidebarWidth}px`;
        }
    }

    /**
     * Show the overlay
     */
    show(onCancel) {
        this.onCancel = onCancel;
        if (this.overlay) {
            // Adjust position before showing
            this.adjustOverlayPosition();
            this.overlay.classList.remove('hidden');
            this.overlay.classList.add('flex');
            this.isVisible = true;
            console.log('🔒 Viewer overlay shown');
        }
    }

    /**
     * Hide the overlay
     */
    hide() {
        if (this.overlay) {
            this.overlay.classList.add('hidden');
            this.overlay.classList.remove('flex');
            this.isVisible = false;
            this.onCancel = null;
            console.log('🔓 Viewer overlay hidden');
        }
    }

    /**
     * Remove the overlay from DOM
     */
    dispose() {
        if (this.overlay && this.overlay.parentNode) {
            this.overlay.parentNode.removeChild(this.overlay);
            this.overlay = null;
            console.log('✅ Viewer overlay disposed');
        }
    }
}
